import React from 'react';
import { RoomData } from '@/AppRedux/actions/booking/bookingApiType';
import { GoogleHotelProfile, GoogleHotelSearch } from './types';
import HotelProfileMeta from './HotelProfileMeta';
import HotelRoomPriceMeta from './HotelRoomPriceMeta';

interface GoogleHotelMarkupProps {
  hotel: GoogleHotelProfile | null;
  rooms: RoomData[];
  search: GoogleHotelSearch;
}

const GoogleHotelMarkup: React.FC<GoogleHotelMarkupProps> = ({ hotel, rooms, search }) => {
  if (!hotel) {
    return null;
  }

  return (
    <div itemScope itemType="https://schema.org/Hotel" style={{ display: 'none' }} aria-hidden="true">
      <HotelProfileMeta
        hotelId={hotel.hotelId}
        hotelName={hotel.hotelName}
        description={hotel.description}
        images={hotel.images}
        address={hotel.address}
        facilities={hotel.facilities}
      />

      {rooms?.length > 0 && (
        <HotelRoomPriceMeta
          rooms={rooms}
          search={search}
          currency={hotel.currency}
          checkInTime={hotel.checkInTime}
          checkOutTime={hotel.checkOutTime}
        />
      )}
    </div>
  );
};

export default GoogleHotelMarkup;
